import React from 'react';

import cn from '@/utils/cn.util';

import LoggedMenuItems from './logged-menu-items';
import NotLoggedMenuItems from './not-logged-menu-items';

interface MenuProps {
  isSignedIn: boolean;
}

const Menu = ({ isSignedIn }: MenuProps): React.JSX.Element => {
  return (
    <div className={cn('flex items-center gap-2 justify-between w-auto')}>
      {isSignedIn ? <LoggedMenuItems /> : <NotLoggedMenuItems />}
    </div>
  );
};

export default Menu;
